<template>
  <v-app>
    <mybar/>
    <cookie />
    <v-content>
      <router-view/>
    </v-content>
    <myfooter/>
  </v-app>
</template>

<script>
  import mybar from './components/Bar'
  import myfooter from './components/Footer'
  import cookie from "@/components/Cookie";
export default {
  name: 'App',
  components: {
    mybar,
    myfooter,
    cookie
  },
  methods: {
    re: function (link) {
      if(link.slice(0,1) === "#"){
        this.$router.push("/");
        this.$vuetify.goTo(link,)
      } else {
        this.$router.push(link);
      }
    },
    route: function(){
      // eslint-disable-next-line no-console
      console.log(this.$route.fullPath);
      return this.$route.fullPath === "/";
    }

  },
  data: () => ({
  }),
};
</script>
